import React from 'react';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { AboutDestaMeet } from '../components/sections/AboutDestaMeet';
import { WhatWeDoForYou } from '../components/sections/WhatWeDoForYou';
import { WhyDestaMeet } from '../components/sections/WhyDestaMeet';
import { RoiStats } from '../components/sections/RoiStats';
import { ProcessTimeline } from '../components/sections/ProcessTimeline';
import { SocialProof } from '../components/sections/SocialProof';
import { CtaSection } from '../components/sections/CtaSection';
export function Home() {
  return <>
      <Hero data-id="element-2587" />
      <TrustBar data-id="element-2588" />
      <AboutDestaMeet data-id="element-2589" />
      <WhatWeDoForYou data-id="element-2590" />
      <WhyDestaMeet data-id="element-2591" />
      <RoiStats data-id="element-2592" />
      <ProcessTimeline data-id="element-2593" />
      <SocialProof data-id="element-2594" />
      <CtaSection data-id="element-2595" />
    </>;
}